import { useState, useEffect } from 'react';
import { Song } from '../components/view/spotipitan/types';
import { UnifiedTrack } from '../utils/apiTypes';
import { resolveSongTrack } from '../utils/api';

export interface UseResolvedTrackResult {
    resolvedTrack: UnifiedTrack | null;
    title: string;
    artistText: string;
    loading: boolean;
}

export const useResolvedTrack = (song?: Song | null): UseResolvedTrackResult => {
    const [resolvedTrack, setResolvedTrack] = useState<UnifiedTrack | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        if (!song?.id) {
            setResolvedTrack(null);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setResolvedTrack(null);

        resolveSongTrack(song).then((track) => {
            if (cancelled) return;
            setResolvedTrack(track);
            setLoading(false);
        }).catch(() => {
            if (cancelled) return;
            setResolvedTrack(null);
            setLoading(false);
        });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [song?.id, song?.name, song?.author_name]);

    const title = resolvedTrack?.title || song?.name || (song ? "" : "Selecciona una canción");

    const artistText = (resolvedTrack?.artists && resolvedTrack.artists.length > 0)
        ? resolvedTrack.artists.map(a => a.name).join(', ')
        : (resolvedTrack?.artist || song?.author_name || song?.user?.username || (song ? "" : "Spotip17an®"));

    return {
        resolvedTrack,
        title,
        artistText,
        loading
    };
};

export default useResolvedTrack;
